import React from 'react';
import {
    Modal,
    ModalHeader,
    SIZE,
    ROLE
  } from "baseui/modal";
import MobilePageContainer from './MobilePageContainer';
import ChallengePageBody from './components/ChallengePageBody';

const ChallengePagePopup = ({ onClose, isOpen, title="TURING CHALLENGES", description_heading=null, description_body=null }) => {
    const ChallengePageBodyComponent = (props) => <ChallengePageBody {...props} description_body={description_body} description_heading={description_heading} />
    return (
        <div>
            {
               isOpen ?  (
                <Modal
                onClose={onClose}
                isOpen={isOpen}
                size={SIZE.default}
                role={ROLE.alertdialog}
            >
                <ModalHeader>{title}</ModalHeader>
                <MobilePageContainer
                    MainBodyComponent={ChallengePageBodyComponent} 
                    event_name="MOBILE_SCREEN_BLOCKER_V2"
                    api_data={{
                        endpoint: "user/send-login-link",
                        body: { redirectPath: window.location.pathname, version: 'v2' }
                    }}
                />
            </Modal>
               ) : null
            }
        </div>
    );
};

export default ChallengePagePopup;
